angular.module('vastdesk').
  component('userSessionForm',  {
    bindings: {
      isProduction: '@',
      otpPath: '@',
      preOtpPath: '@',
      sessionPath: '@',
      email: '@',
      preOtpAuthToken: '@',
      sessionAuthToken: '@'
    },
    template: require("../templates/userSessionForm.html"),
    controllerAs: '$userSessionFormCtrl',
    controller: ['$scope', function($scope) {
      var self = this;
      this.passwordInputType = 'password';

      var stepOneForm = $('#step_1');
      var bodySelector = $('body');

      this.toggleShowPassword = function() {
        self.passwordInputType = (self.passwordInputType === 'password') ? 'text' : 'password';
      };

      this.showTwoFactorFields = function() {
        return self.otpEnabled;
      };

      this.magniteSSOButtons = () => {
        return /(?:magnite|springserve|magnite-springserve-[^.]+)\.com/.test(window.location.hostname);
      };

      this.vizioSSOButtons = () => {
        return window.location.hostname.includes("ads.vizio.com");
      };

      this.frndlytvSSOButtons = () => {
        return window.location.hostname.includes("ads.frndlytv.com");
      };
      this.yuppadsSSOButtons = () => {
        return window.location.hostname.includes("ads.yuppads.com");
      };

      this.amagiSSOButtons = () => {
          return window.location.hostname.includes("adserve.amagi.com");
      };

      this.kidoodleSSOButtons = () => {
        return window.location.hostname.includes("ads.kidoodle.tv");
      };

      this.goldbachSSOButtons = () => {
        return window.location.hostname.includes("ads.goldbach-germany.de") || window.location.hostname.includes("ads.goldvertise.com");
      };

      stepOneForm.on('submit', function (e) {
        e.preventDefault();

        $.post(self.otpPath, {"user[email]": $('#user_email').val()}, function (json) {
          if (Object.prototype.hasOwnProperty.call(json, 'two_factor_required_expiration') && json.two_factor_required_expiration) {
            self.twoFactorExpired = true;
          } else {
            configureForm(json.otp_enabled);
          }
          $scope.$apply();
        });
      });

      var configureForm = function(otp_enabled) {
        self.step2 = true;

        var stepTwoForm = $('#step_2');
        stepTwoForm.find('#user_email_2').val(stepOneForm.find('#user_email').val());
        stepTwoForm.find('#user_password').focus();

        if (otp_enabled) {
          self.otpEnabled = true;
          $('#step_2_otp').attr('required', 'required');
        }
      };

      bodySelector.on('click', '#subscribe_modal .btn-ss-submit', function() {
        $('#subscribe_modal').modal('hide');
      });
    }]
});
